import React, { FC } from 'react';

export const ClientSideOnly: FC = ({ children }) => {
  const isSSR = typeof window === 'undefined';

  return isSSR ? null : <>{children}</>;
};
